//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: () => ({

  })
}



// WEBPACK FOOTER //
// ./src/components/loading/car.vue